import { render, staticRenderFns } from "./PelletsTableSection.vue?vue&type=template&id=497550c2&scoped=true"
import script from "./PelletsTableSection.vue?vue&type=script&lang=ts"
export * from "./PelletsTableSection.vue?vue&type=script&lang=ts"
import style0 from "./PelletsTableSection.vue?vue&type=style&index=0&id=497550c2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497550c2",
  null
  
)

export default component.exports